import React, {Fragment, PureComponent} from 'react'
import {
  APP_URL,
  DIMENSION_ATTRIBUTES,
  PAGE_PREFIX,
  SHAPE_ATTRIBUTES_MAP,
} from '../utils/config.js'
import { Link } from 'react-router-dom'
import {
  setAdditionalShape,
  setCanProceedToNextStep,
  setCustomTemplateTutorialVisible,
  setFastenerPlacement,
  setIndividualRoundedBack,
  setIndividualRoundedSeat,
  setSelectedDimensions,
  setSelectedShape,
} from '../actions/generalActions.js'
import { connect } from 'react-redux'
import { withRoutingTracker } from '../HOC/withRoutingTracker.js'
import { BarLoader } from 'react-spinners'
import {
  setCushionDimensions,
  setInitialCushionDimensions,
  setIsHalfInchRemoved,
} from '../actions/cushionActions.js'
import { displayToast, getEstimate, scrollTo as customScrollTo, slugify, sendGtag } from '../utils/utils.js'
import _, { debounce } from 'lodash'
// import StepTitle from './StepTitle/index.js'
import ToggleButton from './Templates/ToggleButton.js'
// import RoundedOptionCard from './Templates/RoundedOptionCard.js'
import InfoModal from './Templates/InfoModal.js'
import SwiperComponent from './Swiper/index.js'

const shapeButtons = [
  { id: 1, label: 'Back Shape', slug: 'back-shape' },
  { id: 2, label: 'Seat Shape', slug: 'seat-shape' },
]

class CushionShapeSelector extends PureComponent {
  constructor(props) {
    super(props)

    const {
      general: { dimensions },
      cushion: { cushionDimensions },
    } = props

    const shouldSetInitialShapeAndDimensions = !!Object.keys(dimensions).length

    this.state = {
      temporaryAdditionalShape: null,
      temporaryShape: null,
      // When editing, we want to remember the original cushion dimensions in case the user has previously selected cushion A,
      // comes to this step, chooses cushion B (which has different names for dimensions), then goes back to cushion A.
      initialCushionDimensions: shouldSetInitialShapeAndDimensions ? dimensions : null,
      initialPossibleCushionDimensions: shouldSetInitialShapeAndDimensions
        ? cushionDimensions
        : null,

      selectedToggleId: 1,
      isModalOpen: false,
      initialSlideIndex: null,
      isMobile: false,
    }
  }

  handleResize = () => {
    const { isMobile } = this.state

    if (!isMobile && window.innerWidth < 769) {
      this.setState({ isMobile: true })
    }
    else if (isMobile && window.innerWidth > 769) {
      this.setState({ isMobile: false })
    }
  }

  componentDidMount() {
    const { general, dispatch, cushion, params } = this.props
    const { shape } = general
    const { cushionShapes } = cushion

    dispatch(setCanProceedToNextStep(shape !== null))

    if (general?.type?.id === 11741 || general?.type?.id === 11752) {
      const defaultShape = cushionShapes?.find((shape) => shape.id === 859)
      if (defaultShape) {
        if (general?.shape?.id !== defaultShape?.id) {
          sendGtag('add_shape', `${general?.type?.name}_${defaultShape?.name}`)
        }

        dispatch(setSelectedShape(defaultShape, true))
      }
    }

    if (params.shape) {
      scrollTo('cushion-shape-selector-grid', 0)
    }

    if (general.type?.name?.toLowerCase().includes('custom')) {
      this.customTutorialTimeout = setTimeout(() => {
        const { general } = this.props
        const { customTemplateTutorialVisible } = general
        if (!customTemplateTutorialVisible) {
          this._toggleCustomTemplateTutorial()
        }
      }, 100)
    }

    window.addEventListener('resize', debounce(this.handleResize, 1000))

    if (window.innerWidth < 769) {
      this.setState({ isMobile: true })
    }
  }

  componentDidUpdate(prevProps) {
    const { initialCushionDimensions, initialPossibleCushionDimensions } = this.state
    const { cushion, params, dispatch, history, general } = this.props
    const { cushionShapes } = cushion

    // update slider index
    this._calculateSlideIndex()

    if (prevProps.cushion.cushionShapes !== cushionShapes) {
      if (cushionShapes && params?.shape?.id !== 'shape') {
        let selectedShape = cushionShapes.find((shape) => shape.id.toString() === params.shape.id)
        if (selectedShape) {
          dispatch(setCanProceedToNextStep(true))
        } else {
          history.push(`/cd/${params.category}/type`)
          displayToast(
            'The URL you were trying to access is broken. Please reselect your options',
            'error',
          )
        }
        if (params.shape.additionalShapeId) {
          this._selectCushionAdditionalShape(
            cushionShapes.find((shape) => shape.id.toString() === params.shape.additionalShapeId),
          )()
        }
      }
    }
    // This condition will make it so if the user goes back to a shape for which the dimensions are the same as the dimensions
    // that they have chosen already, the dimensions will not be reset.
    if (
      initialPossibleCushionDimensions &&
      prevProps.cushion.cushionDimensions !== cushion.cushionDimensions &&
      _.isEqual(cushion.cushionDimensions, initialPossibleCushionDimensions) &&
      initialCushionDimensions
    ) {
      dispatch(setSelectedDimensions(initialCushionDimensions))
    } else if (!_.isEqual(prevProps.cushion.cushionDimensions, cushion.cushionDimensions)) {
      // Otherwise, we want to unset the selected dimensions, if the cushion dimensions differ (and the above condition is not met!)
      dispatch(setSelectedDimensions({}))
    }

    // If dimensions change, fetch the price estimate
    if (!_.isEqual(prevProps.general.dimensions, general.dimensions)) {
      this._getPrice()
    }

    // check if type has changed
    if (prevProps.general.type !== general.type) {
      if (general.type?.name?.toLowerCase().includes('custom') && !this.customTutorialTimeout) {
        this.customTutorialTimeout = setTimeout(() => {
          const { general } = this.props
          const { customTemplateTutorialVisible } = general
          if (!customTemplateTutorialVisible) {
            this._toggleCustomTemplateTutorial()
          }
        }, 100)
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', debounce(this.handleResize, 1000))
  }

  _calculateSlideIndex() {
    const {
      cushion: { cushionShapes },
      general: { shape },
    } = this.props

    if (cushionShapes && shape) {
      const initialSlideIndex = cushionShapes.findIndex((cushion) => cushion.id === shape.id)

      this.setState({ initialSlideIndex: initialSlideIndex !== null ? initialSlideIndex : null })
    }
  }

  _handleToggle = (selectedToggleId) => {
    this.setState({ selectedToggleId })
  }

  _toggleCustomTemplateTutorial = () => {
    const { dispatch } = this.props
    dispatch(setCustomTemplateTutorialVisible())
  }

  _onOpenModal = () => {
    this.setState({ isModalOpen: true })
  }

  _onCloseModal = () => {
    this.setState({ isModalOpen: false })
  }

  _getPrice = () => {
    const { dispatch, general, params } = this.props
    getEstimate(dispatch, general, params)()
  }

  _getCushionShape = () => {
    const { params, cushion } = this.props
    const { cushionShapes } = cushion
    if (
      cushionShapes &&
      params.shape.id !== 'shape' &&
      cushionShapes.find((shape) => shape.id.toString() === params.shape.id) !== undefined
    ) {
      this._selectCushionShape(
        cushionShapes.find((shape) => shape.id.toString() === params.shape.id),
      )()
      if (params.shape.additionalShapeId) {
        this._selectCushionAdditionalShape(
          cushionShapes.find((shape) => shape.id.toString() === params.shape.additionalShapeId),
        )()
      }
    }
  }

  _getDimensionsDataFromAPI = (dispatch, shape, type) => {
    const { params, layout } = this.props
    const { typesStepView } = layout
    const cushionDimensions = {}

    SHAPE_ATTRIBUTES_MAP[
      typesStepView !== 'allTypes' || params.type?.custom ? 859 : shape.id || type.id
    ].map((dimensionId) => {
      let currentAttribute = type.attributes.find(
        (attribute) => attribute.id.toString() === dimensionId.toString(),
      )
      cushionDimensions[DIMENSION_ATTRIBUTES[dimensionId]] = currentAttribute?.options
    })

    dispatch(setInitialCushionDimensions(cushionDimensions))

    if (params.set) {
      const splitSetSlug = params.set.slug.split('-')
      const shouldRemoveHalfInch = parseInt(splitSetSlug[0]) > 1 || parseInt(splitSetSlug[2]) > 1

      if (shouldRemoveHalfInch) {
        const cushionDimensionsCopy = _.cloneDeep(cushionDimensions)
        cushionDimensionsCopy.width = [...cushionDimensions.width].filter((dimension) =>
          Number.isInteger(parseFloat(dimension)),
        )
        dispatch(setIsHalfInchRemoved(true))
        dispatch(setCushionDimensions(cushionDimensionsCopy))
      }
    }

    dispatch({ type: 'FETCH_ATTRIBUTE_TERMS_BY_ID_SUCCESS' })
  }

  _selectCushionShape = (shape) => () => {
    const { selectedToggleId, isMobile } = this.state
    const { dispatch, general, params } = this.props
    const { type, additionalShape } = general
    if (general.shape?.id === shape?.id) {
      return
    }

    sendGtag('add_shape', `${general?.type?.name}_${shape?.name}`)

    if (params.category === '28' || params.type.id === '11569') {
      this._getDimensionsDataFromAPI(dispatch, { id: null }, type)
    } else {
      this._getDimensionsDataFromAPI(dispatch, shape, type)
    }

    const multipleShapesSelection = [12090, 11864, 11786].includes(type.id)
    const canProceed = multipleShapesSelection
      ? (shape && additionalShape) || shape.id === 859
      : type !== '11569' || additionalShape || shape.id === 859
    dispatch(setSelectedShape(shape, canProceed))
    this.setState({
      temporaryShape: shape,
    })

    // this will reset checkboxes if the user selects a different shape
    dispatch(
      setFastenerPlacement({
        checkboxes: Array(5).fill(0),
        mirroredCheckboxes: Array(5).fill(0),
      }),
    )

    if (multipleShapesSelection && selectedToggleId === shapeButtons[0].id && !additionalShape) {
      setTimeout(() => {
        this._handleToggle(shapeButtons[1].id)

        if (isMobile) {
          customScrollTo('toggle-with-instruction-wrapper', 0, 0, -140)
        }
      }, 700)
    }
  }

  _selectCustomCushionShape = (shape) => () => {
    const { temporaryAdditionalShape, temporaryShape } = this.state
    const { dispatch, general } = this.props
    const { type, shape: selectedShape } = general

    this._getDimensionsDataFromAPI(dispatch, shape, type)

    dispatch(setAdditionalShape(null))

    if (_.isEqual(shape, selectedShape)) {
      dispatch(setAdditionalShape(temporaryAdditionalShape))
      dispatch(setSelectedShape(temporaryShape, true))
    } else {
      dispatch(setSelectedShape(shape, true))
    }

    dispatch(setSelectedDimensions({}))
  }

  _selectCushionAdditionalShape = (shape) => () => {
    const { dispatch, general, } = this.props
    const { selectedToggleId } = this.state
    const { type, shape: selectedShape, } = general
    const multipleShapesSelection = [12090, 11864, 11786].includes(type.id)

    if (general?.additionalShape?.id !== shape?.id) {
      sendGtag('add_additional_shape', `${general?.type?.name}_${shape?.name}`)
    }

    dispatch(setAdditionalShape(shape))
    this.setState({
      temporaryAdditionalShape: shape,
    })
    dispatch(setCanProceedToNextStep(!!general.shape))

    if (multipleShapesSelection && selectedToggleId === shapeButtons[1].id && !selectedShape) {
      setTimeout(() => {
        this._handleToggle(shapeButtons[0].id)
      }, 700)
    }
  }

  _setIndividualRoundedCorners = (value) => {
    const { dispatch } = this.props
    dispatch(setIndividualRoundedBack(value))
  }

  _setIndividualRoundedSeatCorners = (value) => {
    const { dispatch } = this.props
    dispatch(setIndividualRoundedSeat(value))
  }

  _renderCustomTemplateTutorial = () => {
    const { general } = this.props
    const { customTemplateTutorialVisible } = general

    return customTemplateTutorialVisible ? (
      <div className="custom-template-tutorial">
        <div className="custom-template-tutorial-header">
          <h1>Creating a Custom Cushion Template</h1>
          <div className="close-popup">
            <p id="custom-template" onClick={this._toggleCustomTemplateTutorial}>
              &times;
            </p>
          </div>
        </div>
        <div className="custom-template-tutorial-body">
          <p>
            Do you have a seat that is not a rectangle or square? Is it a really odd shape? No
            problem! At Cushion Pros, our craftsmen can create anything you can imagine. In order to
            make your custom cushion we will need a template. A template is a pattern that is cut
            out from paper or cloth; we have found that Craft Paper works best.
          </p>
          <br />
          <p className={'custom-template-tutorial-green-text'}>
            ORDERS MUST BE SUBMITTED PRIOR TO SENDING CUSTOM TEMPLATE(s).
            <br />
          </p>
          <p className={'custom-template-tutorial-green-text italic'}>
            (This ensures the template will be associated with the correct order.)
          </p>
          <p
            className={'custom-template-tutorial-green-text custom-template-tutorial-text-spacing'}
          >
            THE FOLLOWING MUST BE INCLUDED WITH EACH CUSTOM TEMPLATE(s):
          </p>
          <ul>
            <li>Mark your pattern with your name and order number.</li>
            <li>
              Please <u>mark the location of the zipper and placement & type of fasteners.</u>
            </li>
            <li>
              Write your fabric choice, boxed or corded, thickness, and quantity on each template.
            </li>
            <li>Write down any special instructions.</li>
            <li>
              <span className={'custom-template-tutorial-green-text'}>
                The template must be cut out in its entirety.
              </span>
            </li>
          </ul>
          <p>
            By giving us this information there should be no challenge in producing your custom
            cushion.
          </p>
          <br />
          <p>
            <span className="custom-template-tutorial-green-text">Please note, </span> you will need
            to subtract the thickness of the bottom seat cushion from the back cushion. The back
            cushion sits on top of the seat cushion. If the bottom cushion is three inches thick,
            you will need to remove three inches from the back cushion template.
          </p>
          <h4>
            Making a custom cushion template <i>from your existing cushion</i>:
          </h4>
          <ol>
            <li>
              We recommend shipping your existing cushion cover to us. As we create your new custom
              cushion, the existing cover will be deconstructed and will not be returned to you.
            </li>
            <li>
              To make a template, lay the paper on the floor and place your existing cushion on top
              of the paper.
            </li>
            <li>Draw around the outside of the existing cushion.</li>
            <li>Safely cut out the shape to create your custom pattern.</li>
            <li>
              Please be sure to double check your design. Your custom cushion will be exactly the
              same shape and size as the pattern you create.
            </li>
          </ol>
          <h4>
            Making a custom cushion template <i>without</i> an existing cushion:
          </h4>
          <ol>
            <li>Place the paper over the furniture type and press it into place.</li>
            <li>Using a marker, draw along the edge of the furniture.</li>
            <li>Cut along the drawn line to create your custom template.</li>
            <li>Place the cut pattern in the furniture type to ensure that it fits properly.</li>
          </ol>
          <br />
        </div>
        <div className={'custom-template-tutorial-footer'}>
          <p className={'custom-template-tutorial-mailing-address'}>
            Mail your template to:
            <br />
            Cushion Pros
            <br />
            1120 Everee Inn Road
            <br />
            Griffin, Georgia 30224
          </p>
          <br />
          <button
            id="close-custom-template-tutorial"
            type={'submit'}
            className={'custom-template-tutorial-ok-button'}
            onClick={this._toggleCustomTemplateTutorial}
          >
            Agree
          </button>
        </div>
      </div>
    ) : null
  }

  _getShapeImage = (param) => {
    try {
      return require(`../../assets/shapes/${param}.webp`).default
    } catch (error) {
      console.log('Failed to laod image:', error) //eslint-disable-line
      return ''
    }
  }

  _getCushionShapes = () => {
    const { location, general, cushion, params } = this.props
    const { shape, additionalShape, individualRoundedBack, individualRoundedSeat, set } = general
    const { type, category } = params
    const { cushionShapes } = cushion
    let canBeIndividuallyRoundedBack = false
    let canBeIndividually3RoundedBack = false
    let canBeIndividuallyRoundedSeat = false
    let canBeIndividually3RoundedSeat = false
    let splitPathName = location.pathname.split('/')
    const { selectedToggleId, initialSlideIndex } = this.state

    if (general?.type?.id === 13101) {
      cushionShapes.forEach((shape) => {
        if (shape.name === 'Rounded Top') {
          cushionShapes.splice(cushionShapes.indexOf(shape), 1)
        }
      })
    }

    if (set) {
      const splitSetSlug = set.slug.split('-')
      const seatsCount = parseInt(splitSetSlug[0])
      const backsCount = parseInt(splitSetSlug[2])
      // Loveseat (11864) and Sofa (12090) get the -3 image variants when there are 3 sections
      const isLoveseatOrSofa = type.id === '11864' || type.id === '12090'

      canBeIndividuallyRoundedBack = backsCount > 1
      canBeIndividually3RoundedBack = backsCount === 3 && isLoveseatOrSofa
      canBeIndividuallyRoundedSeat = seatsCount > 1
      canBeIndividually3RoundedSeat = seatsCount === 3 && isLoveseatOrSofa
    }

    // change this
    if (category === '28' && type.id !== '166') {
      // if type is chair, loveseat or sofa
      return (
        <>
          <ToggleButton selectedItemId={ selectedToggleId } items={shapeButtons} onToggle={this._handleToggle} />
          <div className={'cushion-shape-selector-wrapper'}>
            <div
              className={`cushion-shape-selector-grid`}
            >
              {name}
              {shape?.id !== 859 ? (
                <>
                  {selectedToggleId === shapeButtons[0].id && (
                    <>
                      {cushionShapes
                        .filter(
                          (cushion) =>
                            cushion.id !== 727 && cushion.id !== 728 && cushion.id !== 859,
                        )
                        .map((cushion, index) => {
                          const canBeIndividuallyRounded = canBeIndividuallyRoundedBack
                          const canBeIndividually3Rounded = canBeIndividually3RoundedBack
                          const sectionsSuffix = canBeIndividually3Rounded ? '-3' : canBeIndividuallyRounded ? '-2' : ''
                          const splitImageSuffix = canBeIndividually3Rounded ? '-3' : ''
                          const splitImageClass = canBeIndividually3Rounded ? 'tripled' : 'doubled'
                          // if Rounded Top, Rounded Bottom or Rounded Corners - we need to show the option to select individual rounded corners
                          if (canBeIndividuallyRounded && (cushion.id === 787 || cushion.id === 30 || cushion.id === 788)) {
                            let outerImage, allImage, titleQualifier
                            if (cushion.id === 30) {
                              outerImage = `outer-corners-rounded${splitImageSuffix}`
                              allImage = `all-corners-rounded${splitImageSuffix}`
                              titleQualifier = ''
                            } else if (cushion.id === 787) {
                              outerImage = `outer-top-corners-rounded${splitImageSuffix}`
                              allImage = `all-top-corners-rounded${splitImageSuffix}`
                              titleQualifier = 'Top'
                            } else {
                              outerImage = canBeIndividually3Rounded ? 'outer-bottom-corners-rounded-3' : 'outer-bottom-corners-rounded'
                              allImage = canBeIndividually3Rounded ? 'rounded-bottom-3' : 'rounded-bottom-2'
                              titleQualifier = 'Bottom'
                            }
                            return (
                              <Fragment key={cushion.id}>
                                <div
                                  id={`cushion-shape-selector-back-${index}`}
                                  onClick={() => {
                                    this._selectCushionShape(cushion)()
                                    this._setIndividualRoundedCorners(false)
                                  }}
                                  className={`cushion-shape-selector-card ${!individualRoundedBack && shape?.id === cushion.id ? 'active' : ''}`}
                                >
                                  <div className={'cushion-shape-selector-card-checkbox'}>
                                    {!individualRoundedBack && shape?.id === cushion.id && (
                                      <img
                                        src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`}
                                      />
                                    )}
                                  </div>
                                  <img className={splitImageClass} src={this._getShapeImage(outerImage)}/>
                                  <div className="card-title">
                                    Outer {titleQualifier && `${titleQualifier} `}Corners Rounded
                                  </div>
                                </div>
                                <div
                                  id={`cushion-shape-selector-back-${index}`}
                                  onClick={() => {
                                    this._selectCushionShape(cushion)()
                                    this._setIndividualRoundedCorners(true)
                                  }}
                                  className={`cushion-shape-selector-card ${individualRoundedBack && shape?.id === cushion.id ? 'active' : ''}`}
                                >
                                  <div className={'cushion-shape-selector-card-checkbox'}>
                                    {individualRoundedBack && shape?.id === cushion.id && (
                                      <img
                                        src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`}
                                      />
                                    )}
                                  </div>
                                  <img className={splitImageClass} src={this._getShapeImage(allImage)}/>
                                  <div className="card-title">
                                    All {titleQualifier && `${titleQualifier} `}Corners Rounded
                                  </div>
                                </div>
                              </Fragment>
                            )
                          }
                          return (
                            <div
                              id={`cushion-shape-selector-back-${index}`}
                              key={cushion.id}
                              onClick={() => {
                                this._selectCushionShape(cushion)()
                                this._setIndividualRoundedCorners(false)
                              }}
                              className={`cushion-shape-selector-card ${shape?.id === cushion.id ? 'active' : ''}`}
                            >
                              <div className={'cushion-shape-selector-card-checkbox'}>
                                {shape?.id === cushion.id && (
                                  <img
                                    src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`}
                                  />
                                )}
                              </div>
                              <img className={canBeIndividually3Rounded ? "tripled" : canBeIndividuallyRounded ? "doubled" : ""} src={this._getShapeImage(`${cushion.slug}${sectionsSuffix}`)} />
                              <div className="card-title">{cushion.name}</div>
                            </div>
                          )
                        })}
                    </>
                  )}
                  {selectedToggleId === shapeButtons[1].id && (
                    <>
                      {cushionShapes
                        .filter(
                          (cushion) =>
                            cushion.id !== 727 && cushion.id !== 728 && cushion.id !== 859,
                        )
                        .map((cushion, index) => {
                          splitPathName[splitPathName.length - 1] = cushion.id
                          const canBeIndividuallyRounded = canBeIndividuallyRoundedSeat
                          const canBeIndividually3Rounded = canBeIndividually3RoundedSeat
                          const sectionsSuffix = canBeIndividually3Rounded ? '-3' : canBeIndividuallyRounded ? '-2' : ''
                          const splitImageSuffix = canBeIndividually3Rounded ? '-3' : ''
                          const splitImageClass = canBeIndividually3Rounded ? 'tripled' : 'doubled'
                          // if Rounded Top, Rounded Bottom or Rounded Corners - we need to show the option to select individual rounded corners
                          if (canBeIndividuallyRounded && (cushion.id === 787 || cushion.id === 30 || cushion.id === 788)) {
                            let outerImage, allImage, titleQualifier
                            if (cushion.id === 30) {
                              outerImage = `outer-corners-rounded${splitImageSuffix}`
                              allImage = `all-corners-rounded${splitImageSuffix}`
                              titleQualifier = ''
                            } else if (cushion.id === 787) {
                              outerImage = `outer-top-corners-rounded${splitImageSuffix}`
                              allImage = `all-top-corners-rounded${splitImageSuffix}`
                              titleQualifier = 'Top'
                            } else {
                              outerImage = canBeIndividually3Rounded ? 'outer-bottom-corners-rounded-3' : 'outer-bottom-corners-rounded'
                              allImage = canBeIndividually3Rounded ? 'rounded-bottom-3' : 'rounded-bottom-2'
                              titleQualifier = 'Bottom'
                            }
                            return (
                              <Fragment key={cushion.id}>
                                <div
                                  id={`cushion-shape-selector-seat-${index}`}
                                  onClick={() => {
                                    this._selectCushionAdditionalShape(cushion)()
                                    this._setIndividualRoundedSeatCorners(false)
                                  }}
                                  className={`cushion-shape-selector-card ${!individualRoundedSeat && additionalShape?.id === cushion.id ? 'active' : ''}`}
                                >
                                  <div className={'cushion-shape-selector-card-checkbox'}>
                                    {!individualRoundedSeat && additionalShape?.id === cushion.id && (
                                      <img
                                        src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`}
                                      />
                                    )}
                                  </div>
                                  <img className={splitImageClass} src={this._getShapeImage(outerImage)}/>
                                  <div className="card-title">
                                    Outer {titleQualifier && `${titleQualifier} `}Corners Rounded
                                  </div>
                                </div>
                                <div
                                  id={`cushion-shape-selector-seat-${index}`}
                                  onClick={() => {
                                    this._selectCushionAdditionalShape(cushion)()
                                    this._setIndividualRoundedSeatCorners(true)
                                  }}
                                  className={`cushion-shape-selector-card ${individualRoundedSeat && additionalShape?.id === cushion.id ? 'active' : ''}`}
                                >
                                  <div className={'cushion-shape-selector-card-checkbox'}>
                                    {individualRoundedSeat && additionalShape?.id === cushion.id && (
                                      <img
                                        src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`}
                                      />
                                    )}
                                  </div>
                                  <img className={splitImageClass} src={this._getShapeImage(allImage)}/>
                                  <div className="card-title">
                                    All {titleQualifier && `${titleQualifier} `}Corners Rounded
                                  </div>
                                </div>
                              </Fragment>
                            )
                          }
                          return (
                            <div
                              id={`cushion-shape-selector-seat-${index}`}
                              key={cushion.id}
                              onClick={() => {
                                this._selectCushionAdditionalShape(cushion)()
                                this._setIndividualRoundedSeatCorners(false)
                              }}
                              className={`cushion-shape-selector-card ${additionalShape?.id === cushion.id ? 'active' : ''}`}
                            >
                              <div className={'cushion-shape-selector-card-checkbox'}>
                                {additionalShape?.id === cushion.id && (
                                  <img
                                    src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`}
                                  />
                                )}
                              </div>
                              <img className={canBeIndividually3Rounded ? "tripled" : canBeIndividuallyRounded ? "doubled" : ""} src={this._getShapeImage(`${cushion.slug}${sectionsSuffix}`)} />
                              <div className="card-title">{cushion.name}</div>
                            </div>
                          )
                        })}
                    </>
                  )}
                </>
              ) : null}
            </div>
          </div>
        </>
      )
    }

    // Render slides
    const slides = Array.from(
      cushionShapes.map((cushion, index) => {
        splitPathName[splitPathName.length - 1] = `${cushion.id}-${slugify(cushion.name)}`
        const replacedPathName = splitPathName.join('/')
        return (
          <div
            id={`cushion-shape-selector-card-${index}`}
            key={cushion.id}
            onClick={this._selectCushionShape(cushion)}
            className={`cushion-shape-selector-card ${shape?.id === cushion.id ? 'active' : ''}`}
          >
            <div className={'cushion-shape-selector-card-checkbox'}>
              {shape?.id === cushion.id && (
                <img src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`} />
              )}
            </div>
            <img src={this._getShapeImage(cushion.slug)} />
            <Link to={`${PAGE_PREFIX}${replacedPathName}/dimensions`}>
              <div className="card-title">{cushion.name}</div>
            </Link>
          </div>
        )
      }),
    )
    return (
      <div className={'cushion-shape-selector-swiper'}>

        <SwiperComponent
          className={'cushion-type-selector'}
          slides={slides}
          slidesPerView={1}
          slidesPerGroup={1}
          initialSlideIndex={initialSlideIndex}
          slideEventName="scroll_button_shape"
        />
      </div>
    )
  }

  render() {
    const { cushion, general } = this.props
    const { cushionShapes } = cushion
    const { type } = general

    if (cushionShapes === null) {
      return (
        <div className={'cushion-shape-selector'}>
          <BarLoader color={'#93C44E'} css={{ position: 'absolute' }} />
        </div>
      )
    }

    return (
      <>
        <InfoModal
          isOpen={this.state.isModalOpen}
          onOpen={this._onOpenModal}
          onClose={this._onCloseModal}
          modalClassName="shape-selector-modal"
        >
          <p className={'cd-modal-text'}>
            {type?.id === 166
              ? 'Please note that when selecting Rounded – your custom cushion’s corner will be cut at a 5 degree radius. If your furniture requires a radius smaller, or larger then you must go back and select Custom Template at Step 1.'
              : 'Please note that when selecting Rounded, Rounded Front, or Rounded Back – your custom cushion’s corner will be cut at a 5 degree radius. If your furniture requires a radius smaller, or larger then you must go back and select Custom Template at Step 1.'}
          </p>
        </InfoModal>
        {this._renderCustomTemplateTutorial()}
        <div className={'cushion-designer-layout'}>
          <p className={'cushion-designer-footer-text'}>
            {type?.id === 166
              ? 'Please note that when selecting Rounded – your custom cushion’s corner will be cut at a 5 degree radius. If your furniture requires a radius smaller, or larger then you must go back and select Custom Template at Step 1.'
              : 'Please note that when selecting Rounded, Rounded Front, or Rounded Back – your custom cushion’s corner will be cut at a 5 degree radius. If your furniture requires a radius smaller, or larger then you must go back and select Custom Template at Step 1.'}
          </p>
          <div className={'cushion-shape-selector'}>{this._getCushionShapes()}</div>
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
  cushion: state.cushion,
  layout: state.layout,
})

export default withRoutingTracker(connect(mapStateToProps)(CushionShapeSelector))
